export const acceptedFilesTypography = {
	".csv": "title_DragAndDropTheCSVFileHereOrClickToSelect",
	".zip": "title_DragAndDropTheZipFileHereOrClickToSelect",
	all: "title_DragAndDropTheFileHereOrClickToSelect",
};
